
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ToastProvider } from './contexts/ToastContext';

// Service Worker is now handled automatically by vite-plugin-pwa via 'injectRegister: auto' in vite.config.ts
// No manual registration needed here.

console.log("index.tsx executing");

// Global error handlers: Log to console but don't block UI with ugly overlay
window.onerror = function(message, source, lineno, colno, error) {
  console.group('Fairyrealm Runtime Error');
  console.error('Message:', message);
  console.error('Source:', source, 'Line:', lineno, 'Col:', colno);
  console.error('Error Object:', error);
  console.groupEnd();
  // Don't prevent default, let browser/React ErrorBoundary handle it
};

window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled Promise Rejection:', event.reason);
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);
